import { createContext } from 'react';
export var IndexContext = /*#__PURE__*/createContext(null);
if (process.env.NODE_ENV === 'development') {
  IndexContext.displayName = 'Index';
}